export const WORK_PAGE_NS = 'pages/WorkPage';

export const i18n = {
  en: {
    section: {
      untitledSection: 'Untitled Section',
      notAllowedCharacters:
        'The following characters are not allowed: [`_=~!@#$%^&*()+[{]}|;:\'"/,?<.>]/',
    },
    tabs: {
      workflow: 'Workflow',
      navigation: 'Navigation',
      chat: 'Chat',
      activities: 'Activities',
      relatedWork: 'Related Work',
    },
    status: {
      New: 'New',
      Created: 'Created',
      Complete: 'Completed',
      InProgress: 'Pending',
      Skipped: 'Skipped',
      Declined: 'Declined',
      Deleted: 'Deleted',
      Cancelled: 'Cancelled',
      Pending: 'Pending',
    },
    userStatus: {
      New: 'New',
      Created: 'Created By',
      Complete: 'Completed By',
      InProgress: 'Pending',
      Skipped: 'Skipped By',
      Declined: 'Declined By',
      Deleted: 'Deleted By',
      Cancelled: 'Cancelled By',
      Pending: 'Pending',
    },
    step: {
      unauthorised: 'YOU DO NOT HAVE PERMISSION TO ACCESS THIS DATA.',
      activeTask: 'Active task',
      noPermission: 'No permission',
      noActivities: 'No activities yet',
    },
    buttons: {
      videoChat: 'Join',
      delete: 'Delete',
      print: 'Print',
      allActivities: 'All Activities',
      goBack: 'Go Back',
    },
    confirmDelete: {
      title: 'Are you sure to delete work item {{ item }}?',
      description: 'Note: Deleted items can be restored from the performance view.',
    },
    deleteNotifications: {
      success: {
        message: 'Work item deleted.',
        description: 'Work item successfully deleted.',
      },
      error: {
        message: 'Failed to delete work item',
        description: 'Something went wrong.',
      },
    },
    relatedWork: {
      empty: 'No related work',
      relationship: {
        type: 'Relationship type',
      },
    },
    activity: {
      labels: {
        search: 'Search',
        noResult: 'No Result',
      },
      verbs: {
        created: 'created',
        completed: 'completed',
        submitted: 'submitted',
        sentBack: 'sent back',
        skipped: 'skipped',
        declined: 'declined',
        deleted: 'deleted',
        generatedWorkItem: 'generated new work item',
        edited: 'edited',
        updatedPermissions: 'updated permissions for',
        commented: 'left a comment',
      },
    },
    taskToolbar: {
      actions: {
        edit: 'Edit',
        editPermission: 'Edit permission',
        sendBack: 'Send back',
        notify: 'Notify',
        cancel: 'Cancel',
      },
    },
    workflowMenu: {
      edit: 'Edit',
      duplicate: 'Duplicate',
      delete: 'Delete',
      confirmDelete: 'Are you sure to delete {{name}}?',
    },
    commentsDrawer: {
      send: 'Send',
      title: 'Comments',
      inputPlaceholder: 'Type a comment ...',
      edit: 'Edit',
      delete: 'Delete',
      deleting: 'Deleting..',
      save: 'Save',
      cancel: 'Cancel',
      noComments: 'No comments yet',
    },
    errorMessage: {
      cannotRenameSection: 'There was an error during section renaming.',
    },
  },
};
